import { Autocomplete, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function BigQueryDatasetSelector({
  selectedDataset = null,
  onSelectDataset,
  showError = false,
  label = "Select dataset",
  title = null,
  datasetsFilter = null,
}) {
  BigQueryDatasetSelector.propTypes = {
    selectedDataset: PropTypes.string,
    onSelectDataset: PropTypes.func.isRequired,
    showError: PropTypes.bool,
    label: PropTypes.string,
    title: PropTypes.string,
    datasetsFilter: PropTypes.func,
  };

  const { projectId } = useParams();
  const [didUserTouchField, setDidUserTouchField] = useState(false);
  const [datasetsOptions, setDatasetsOptions] = useState([]);
  const showFieldError = !selectedDataset && (didUserTouchField || showError);

  useEffect(() => {
    const fetchDatasets = async () => {
      try {
        const queryParams = new URLSearchParams();
        queryParams.set("project_id", projectId);
        const response = await fetch(`/bigquery/list-datasets/?${queryParams.toString()}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Apply filter if provided
        const filteredData = datasetsFilter ? data.filter(datasetsFilter) : data;
        setDatasetsOptions(filteredData);
      } catch (error) {
        console.error("Error fetching datasets:", error);
      }
    };

    fetchDatasets();
  }, [projectId, datasetsFilter]);

  return (
    <>
      {title && (
        <Typography variant="h4" sx={{ mb: 2 }}>
          {title}
        </Typography>
      )}
      <Autocomplete
        id="dataset-selector"
        value={selectedDataset}
        onChange={onSelectDataset}
        loading={datasetsOptions.length === 0}
        options={datasetsOptions}
        noOptionsText={"No datasets match the search term"}
        fullWidth={true}
        sx={{ mb: 1 }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            error={showFieldError}
            onBlur={() => setDidUserTouchField(true)}
            helperText={
              showFieldError ? "Please select a dataset" : " "
            }
          />
        )}
      />
    </>
  );
}